import { render } from "./OrdersSecondaryTitle.vue?vue&type=template&id=b05bb412"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "b05bb412"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b05bb412', script)) {
    api.reload('b05bb412', script)
  }
  
  module.hot.accept("./OrdersSecondaryTitle.vue?vue&type=template&id=b05bb412", () => {
    api.rerender('b05bb412', render)
  })

}

script.__file = "src/views/services/pageTitles/OrdersSecondaryTitle.vue"

export default script